module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-nav-bar', {
    attrs: {
      "title": "修改昵称",
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.onClickLeft
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c('van-icon', {
          attrs: {
            "name": "../../../static/images/mobile/back.png",
            "size": "18"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-form', {
    attrs: {
      "validate-first": ""
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('van-field', {
    attrs: {
      "maxlength": "16",
      "name": "pattern",
      "placeholder": "请输入16位字符以内，字母、数字、汉字任意组合",
      "rules": [{
        pattern: _vm.pattern,
        message: '请输入正确昵称'
      }]
    },
    on: {
      "input": _vm.changColor
    },
    model: {
      value: (_vm.nickName),
      callback: function($$v) {
        _vm.nickName = $$v
      },
      expression: "nickName"
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.phoneNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("提交")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2144cd8a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobilePersonalNickname.vue
// module id = 1137
// module chunks = 41